import { extend } from "quasar";
import { onBeforeRouteLeave } from "vue-router";

export function useForm({
  formModel,
  isForm,
  entity,
  post,
  put,
  toggleForm = () => {},
  formRef,
  editMode = false,
}) {
  const formData = ref(extend(true, {}, formModel()));
  const { setScrollReset } = useAppStore();

  const resetFormValidations = () => {
    nextTick(() => {
      unref(formRef)?.component?.resetValidation();
    });
  };

  const resetForm = (closed) => {
    formData.value =
      !closed && unref(isForm).edit
        ? {
            ...extend(true, {}, formModel()),
            ...extend(true, {}, unref(entity)),
          }
        : extend(true, {}, formModel());
  };

  const closeForm = (reset) => {
    if (reset || unref(isForm).edit) {
      resetForm(true);

      resetFormValidations();
    }

    let closedFormState = { open: false, edit: false, view: false, props: {} };

    if (Object.hasOwn(unref(isForm), "level")) {
      closedFormState.level = unref(isForm).level;
    }

    toggleForm(closedFormState);
  };

  const isLoading = ref(false);

  const submitForm = async (closeAfterSubmission = true) => {
    try {
      isLoading.value = true;

      let submission;

      if (unref(isForm).edit) {
        submission = await put(toRaw(unref(formData)));
      } else {
        submission = await post(toRaw(unref(formData)));

        setScrollReset(true);
      }

      isLoading.value = false;

      if (closeAfterSubmission) {
        closeForm(true);
      }

      return submission;
    } catch (error) {
      isLoading.value = false;

      throw error;
    }
  };

  const validateForm = async () => {
    try {
      return await unref(formRef).component.validate();
    } catch (error) {
      console.error(error);
    }
  };

  watchEffect(() => {
    if ((unref(isForm).edit || editMode) && unref(entity)) {
      nextTick(() => {
        setScrollReset(false);

        formData.value = {
          ...extend(true, {}, formModel()),
          ...extend(true, {}, unref(entity)),
        };
      });
    } else {
      nextTick(() => {
        formData.value = {
          ...extend(true, {}, formModel()),
        };

        resetFormValidations();
      });
    }
  });

  onBeforeRouteLeave(() => {
    resetForm(true);

    resetFormValidations();
  });

  return {
    formData,
    isLoading,

    closeForm,
    resetForm,
    submitForm,
    validateForm,
  };
}
